<template>
  <div class="B2CNameAndCategory mb-24">
    <div class="flex type-tagline">
      <p class="type-tagline-xs text-text-subtle mb-12">
        {{ $t('productPage.partNo.short') }} {{ activeVariant.partNo }}
      </p>
      <div v-if="globalContent.getCountryCode === 'no'" class="mb-12 flex">
        <hr class="h-full w-[1px] mx-8 bg-bg-active">
        <p class="type-tagline-xs text-text-subtle">
          NOBB: {{ activeVariant.parametricByCode('ItemNumberNobb')?.value }}
        </p>
      </div>
    </div>

    <h1 class="type-headline-xl mb-12" v-text="productItem.extendedLayout ? productItem.name : activeVariant.name" />

    <ReadMore
      open-close-class="type-sm text-text-subtle underline"
    >
      <div
        class="type-sm text-text-subtle empty:hidden"
        v-html="description"
      />
    </ReadMore>

    <!-- * * * * * "chips" -->
    <div v-if="chips && chips.length" class="type-xs text-text-attention flex flex-wrap gap-8 mt-16">
      <div
        v-for="(chip, index) in chips"
        :key="index"
        class="inline-flex items-center gap-8 bg-bg-attention px-8 py-4"
      >
        <img
          v-if="chip.image !== ''"
          :src="chip.image"
          :alt="chip.name"
          class="w-20 h-20"
        >
        {{ chip.name }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ProductModel } from '#models/product';
import type { ProductVariantModel } from '#models/productVariant';
import { computed } from 'vue';
import { useGlobalContentStore } from '~/store/globalContent';
const globalContent = useGlobalContentStore();
const props = defineProps<{
  productItem: ProductModel,
  activeVariant: ProductVariantModel,
}>();

const description = computed(()=> {
  if (props.activeVariant.variantDescription !== '') {
    return props.activeVariant.variantDescription;
  }
  return props.productItem.description;
});

const chips = computed(()=> {
  return props.activeVariant.parametricByCode('B2CChips')?.multipleValues?.slice(0,3) || [];
});

</script>
